export default "/images/96f50dde4e1dcee2438e106003d59867.avif";